import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';
import { Router, ActivatedRoute,NavigationExtras } from '@angular/router';
import { SignImageService } from '../../../services/sign-image.service';
@Component({
  selector: 'app-navigation-trigger',
  templateUrl: 'navigation-trigger.component.html',
  styleUrls: ['navigation-trigger.component.scss']
})
export class NavigationTriggerComponent implements OnInit {

  constructor(public service: AppService,private router: Router,private signService: SignImageService,) { }

  openMobileSidebar() {
    this.service.mobileSidebarActive = !this.service.mobileSidebarActive;

  }
  deal_hub_sign:any = false;
  images : any;
  ngOnInit() {
    // After approve remove thubnail hamburger
    this.signService.data.invokeApproveFinishTrue.subscribe(data => {
          this.service.showthreebar =  true;
    });
    // After signature remove thubnail hamburger
    this.signService.data.invokeSignFinishTrue.subscribe(data => {
      this.service.showthreebar =  true;
    });
    this.service.getBtnStatus.subscribe(
      message =>{
        if(typeof message['images']!="undefined"){
          this.images = message['images'];
        }
      }
    )
    this.service.getBtnStatusUpClass.subscribe(
      message => {
        //console.log("navigationnavigationnavigation=======",message);
        if(typeof message!="undefined"){
          this.deal_hub_sign = message;
        }
      }
    )
    var fullRoute = this.router.url;
    if (fullRoute.indexOf('free-sign') > -1 || fullRoute.indexOf('quick-sign') > -1){
      this.service.showthreebar =  true;
    }else if (fullRoute.indexOf('sign') > -1){
      if(this.images!='' && this.images!=null){
        this.service.showthreebar =  false;
      }
    }else{
      this.service.showthreebar = false;
    }
  }

}
